import { IObservable, Observable } from "thrive-observable-react";
import { getToken } from "../../api/login";
import { SUACService } from "../../services/SignUpAppConfig.service";
import { getAndroidAppStoreUrl, getIOSAppStoreUrl } from "../../utils/appStoreUrls";
import httpService from "../../services/http.service";

class DownloadModel {
    public title: string = 'See your customised workspace in your hands';
    public subtitle: string = 'Your demo app is ready! Follow the steps below to experience it.';
    public stepOneHeader: string = "Download Thrive";
    public stepOneInstructions: string = "Get the Thrive app on your phone to see your customised workspace.";
    public stepTwoHeader: string = "Log in with your organisation name";
    public stepThreeHeader: string = "Manage your content and users";
    public stepThreeInstructions: string = "Log in to your Thrive workspace to add content, manage users, and explore the platform.";
    public button: string = "Log in to Thrive Workspace";
    public showErrorBanner : IObservable<boolean> = Observable(false);
    public QRCode: IObservable<string> = Observable('');
    
    private showTemporaryError = () => {
        this.showErrorBanner.update(true);

        setTimeout(() => {
            this.showErrorBanner.update(false);
        }, 6000);
    }

    public setQrCode = async () => {
        const code = await httpService.getQRCodeUrl()
        this.QRCode.update(code);
    }

    public onAppStoreClick() {
        const appStoreUrl = getIOSAppStoreUrl();

        globalThis.open(
            appStoreUrl,
            "_blank",
            "noopener,noreferrer"
        );
    }

    public onGooglePlayClick() {
        const googlePlayUrl = getAndroidAppStoreUrl();
        
        globalThis.open(
            googlePlayUrl,
            "_blank",
            "noopener,noreferrer"
        );
    }
    
    public onNavigateToCMSClick = async () => {
        const params = {	
            username: SUACService.createAppForm.value?.emailAddress ?? "", 
            password: SUACService.createAppForm.value?.password ?? "", 
            orgShortName: SUACService.createAppForm.value?.orgShortName ?? ""
        }

        const res = await getToken(params)
        .catch(() => {
            this.showTemporaryError();
        });

        if (res) {
            //redirect to CMS logged in
            const url = SUACService.cmsUrl.value;
            let cmsQueryparams = `authcallbacklogin.html?access_token=${res.data?.access_token}&refresh_token=${res.data?.refresh_token}&returnPath=${url}`
            if (url) {                    
                globalThis.open(`${url}/${cmsQueryparams}`, '_blank');
            }
        }
    }
}


export { DownloadModel };